import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  FaArrowRight,
  FaXmark,
  FaChevronLeft,
  FaChevronRight,
  FaQuoteLeft,
} from "react-icons/fa6";
import "./NewsArticles.css";

const NEWS_ARTICLES_DATA = [
  {
    id: 1,
    title:
      "Bharat Buildcon – International Building Materials Exhibition Set to Drive $5B Exports",
    excerpt:
      "With the vision of the Hon'ble Prime Minister Shri Narendra Modi Ji to transform India into a global manufacturing power, Bharat Buildcon 2026 unveils India's largest building material export hub.",
    content:
      "Business Standard Report: New Delhi — Bharat Buildcon 2026 was officially inaugurated today as India's premier international trade show for ceramic, granite, glass, and structural engineering products. Aligned with Prime Minister Narendra Modi's vision of 'Make in India for the World', the exhibition brings together over 1,000+ top Indian manufacturers and international buyer delegations from 35+ countries. Industry leaders project over $5 Billion in export agreements during the multi-day event.",
    image:
      "https://images.unsplash.com/photo-1504711434969-e33886168f5c?auto=format&fit=crop&w=1000&q=80",
    tags: [
      "#BusinessStandard",
      "#BharatBuildcon",
      "#MakeInIndia",
      "#GlobalTrade",
    ],
  },
  {
    id: 2,
    title:
      "Bharat Buildcon – Transforming Indian Infrastructure Manufacturing Corridor",
    excerpt:
      "New Delhi: With the vision of the Hon'ble Prime Minister Shri Narendra Modi Ji to transform India's construction ecosystem, global buyers assemble at Yashobhoomi, New Delhi.",
    content:
      "The Wire Coverage: Yashobhoomi Convention Centre witnessed record footfalls on opening day of Bharat Buildcon. International trade delegates from Germany, the UK, UAE, and North America praised the advanced automation in Indian ceramic kiln technology and pre-fabricated concrete solutions showcased at the expo.",
    image:
      "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&w=800&q=80",
    tags: ["#TheWire", "#InfraDevelopment", "#Buildcon2026"],
  },
  {
    id: 3,
    title:
      "ANI Coverage: Bharat Buildcon International Building Materials Expo Opened by Union Ministers",
    excerpt:
      "New Delhi [India]: Union Commerce & Industry Ministry leaders and CAPEXIL dignitaries inaugurate the mega building materials trade expo in New Delhi.",
    content:
      "ANI Report: New Delhi — Asian News International (ANI) reports live from the curtain raiser of Bharat Buildcon. Supporting bodies including CAPEXIL, NAREDCO, and Morbi Ceramic Association emphasized how direct buyer-seller meets are cutting export intermediaries and boosting profit margins for Indian manufacturers.",
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=800&q=80",
    tags: ["#ANINews", "#CAPEXIL", "#NAREDCO", "#ExhibitionLaunch"],
  },
  {
    id: 4,
    title:
      "PTI News: International Buyers Delegations From 35+ Nations Arrive for Bharat Buildcon",
    excerpt:
      "New Delhi: Over 2,500 foreign trade delegates register for B2B buyer meets focusing on ceramic tiles, natural stone, and green concrete formulations.",
    content:
      "PTI Report: Press Trust of India confirms the arrival of foreign buyer delegations from Europe, Latin America, CIS nations, and Southeast Asia. Special bilateral trade corridors have been established to accelerate import-export clearance for building materials.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80",
    tags: ["#PTINews", "#ForeignDelegates", "#B2BMeets", "#GlobalBuyers"],
  },
  {
    id: 5,
    title:
      "Commerce and Industry Minister Shri Piyush Goyal Unveils 'Bharat Buildcon 2026' Curtain Raiser",
    excerpt:
      "Union Commerce and Industry Minister Shri Piyush Goyal today launched the curtain raiser for Bharat Buildcon 2026 in New Delhi, emphasizing FTA advantages.",
    content:
      "PIB Delhi Press Release: Hon'ble Minister for Commerce and Industry, Shri Piyush Goyal, presided over the official curtain raiser of Bharat Buildcon 2026. The Minister highlighted how recently signed Free Trade Agreements (FTAs) with the UK, UAE, Australia, and EFTA nations create unprecedented market access for Indian building material exporters.",
    image:
      "https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&w=800&q=80",
    tags: ["#PIBIndia", "#PiyushGoyal", "#CommerceMinistry", "#FTAAgreements"],
  },
  {
    id: 6,
    title:
      "Shri Piyush Goyal Launches Bharat Buildcon 2026 Curtain Raiser, Spotlight on Exports & FTAs",
    excerpt:
      "Union Commerce and Industry Minister Shri Piyush Goyal unveiled the curtain raiser for Bharat Buildcon 2026 in New Delhi, spotlighting green building tech.",
    content:
      "News18 Infrastructure Feature: India's building material manufacturing sector is undergoing a massive green transition. At the curtain raiser, Minister Piyush Goyal commended Bharat Buildcon for fostering carbon-neutral construction standards and digital BIM innovation.",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80",
    tags: ["#News18", "#ETInfra", "#GreenBuilding", "#ConTech"],
  },
  {
    id: 7,
    title:
      "Government Committed To Protecting Industry, Boosting Exports: Piyush Goyal at Buildcon Expo",
    excerpt:
      "The government is working on support measures for exporters as high global demand for Indian tiles, granite, and steel continue to surge.",
    content:
      "Economic Times Analysis: Indian ceramic and granite manufacturers are capturing significant market share across North America and Europe. The Economic Times analyzes how Bharat Buildcon acts as a catalyst for sustainable export growth.",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
    tags: ["#EconomicTimes", "#ExportBoost", "#IndianIndustry"],
  },
  {
    id: 8,
    title:
      "Piyush Goyal Unveils the 'Bharat Buildcon 2026' Curtain Raiser for Global Port Logistics",
    excerpt:
      "NEW DELHI: Union Commerce and Industry Minister Shri Piyush Goyal launched the curtain raiser for Bharat Buildcon 2026, boosting maritime freight corridors.",
    content:
      "India Shipping News Report: Seamless port logistics, container freight corridors, and customs digitization take center stage as Bharat Buildcon partners with major Indian port trusts for rapid export dispatches.",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
    tags: ["#ShippingNews", "#PortLogistics", "#ContainerExports"],
  },
];

const ARTICLES_PER_PAGE = 6;

const NewsArticles = () => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // Pagination logic
  const totalPages =
    Math.ceil(NEWS_ARTICLES_DATA.length / ARTICLES_PER_PAGE) || 1;
  const currentArticles = NEWS_ARTICLES_DATA.slice(
    (currentPage - 1) * ARTICLES_PER_PAGE,
    currentPage * ARTICLES_PER_PAGE,
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="news-articles-page">
      <Helmet>
        <title>News Articles | Bharat Buildcon</title>
      </Helmet>
      {/* Background Soft Glows */}
      <div className="news-ambient-glow glow-1"></div>
      <div className="news-ambient-glow glow-2"></div>

      {/* HEADER SECTION */}
      <section className="news-header-section">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">NEWS ARTICLES</span>
          </nav>
        </div>

        <h1 className="news-main-title">
          News Articles & <span className="gradient-text">Press Coverage</span>
        </h1>

        <p className="news-subtitle-text">
          Read official press releases, national news headlines, wire agency
          reports, and ministry announcements covering Bharat Buildcon & Vibrant
          Buildcon.
        </p>
      </section>

      {/* 3-COLUMN NEWS CARDS GRID */}
      <section className="news-grid-section">
        <div className="news-cards-grid">
          {currentArticles.map((article) => (
            <div key={article.id} className="news-card-slot">
              <div
                className="news-item-card"
                onClick={() => setSelectedArticle(article)}
              >
                {/* Media Image Box */}
                <div className="card-media-box">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="card-thumb-img"
                  />
                </div>

                {/* Card Content Body */}
                <div className="card-body-wrapper">
                  <div>
                    <div className="card-meta-line"></div>

                    <h3 className="card-headline-title">{article.title}</h3>
                    <p className="card-headline-excerpt">{article.excerpt}</p>
                  </div>

                  {/* Card Footer */}
                  <div className="card-footer-box">
                    <button className="card-open-btn">
                      Read Coverage <FaArrowRight />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION CONTROLS */}
        {totalPages > 1 && (
          <div className="news-pagination-bar">
            <button
              className="page-nav-btn"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaChevronLeft /> Prev
            </button>

            <div className="page-numbers-group">
              {Array.from({ length: totalPages }, (_, index) => {
                const pageNum = index + 1;
                return (
                  <button
                    key={pageNum}
                    className={`page-num-btn ${currentPage === pageNum ? "active" : ""}`}
                    onClick={() => handlePageChange(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>

            <button
              className="page-nav-btn"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next <FaChevronRight />
            </button>
          </div>
        )}
      </section>

      {/* FULL ARTICLE POPUP LIGHTBOX */}
      {selectedArticle && (
        <div
          className="news-modal-backdrop"
          onClick={() => setSelectedArticle(null)}
        >
          <div className="news-modal-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close-btn"
              onClick={() => setSelectedArticle(null)}
              title="Close Article"
            >
              <FaXmark />
            </button>

            <div className="modal-top-media">
              <img
                src={selectedArticle.image}
                alt={selectedArticle.title}
                className="modal-header-img"
              />
            </div>

            <div className="modal-body-container">
              <h2 className="modal-article-title">{selectedArticle.title}</h2>

              <div className="modal-quote-box">
                <FaQuoteLeft className="quote-icon" />
                <p className="modal-quote-text">"{selectedArticle.excerpt}"</p>
              </div>

              <div className="modal-full-content">
                <p>{selectedArticle.content}</p>
              </div>

              <div className="modal-tags-row">
                {selectedArticle.tags.map((tag, idx) => (
                  <span key={idx} className="modal-tag-chip">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsArticles;
